import { render, staticRenderFns } from "./ShippingSelector.vue?vue&type=template&id=06919b90&scoped=true&"
import script from "./ShippingSelector.vue?vue&type=script&lang=js&"
export * from "./ShippingSelector.vue?vue&type=script&lang=js&"
import style0 from "./ShippingSelector.vue?vue&type=style&index=0&id=06919b90&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06919b90",
  null
  
)

export default component.exports